import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import EmployeePicker, { EmployeePickerProps } from '../common/EmployeePicker';

/**
 * Props for FormEmployeePicker.
 * Combines EmployeePicker props with React Hook Form integration.
 */
interface FormEmployeePickerProps<
  TFieldValues extends FieldValues = FieldValues,
> extends Omit<EmployeePickerProps, 'value' | 'onSelect' | 'onClear' | 'invalid'> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
}

/**
 * Wrapper that binds {@link EmployeePicker} to a React Hook Form field. The
 * committed field value is always a lowercase login from PAPI (or the empty
 * string on clear). Free text never becomes the field value.
 */
export const FormEmployeePicker = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  ...pickerProps
}: FormEmployeePickerProps<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <EmployeePicker
          {...pickerProps}
          value={field.value || ''}
          onSelect={(login) => field.onChange(login)}
          onClear={() => field.onChange('')}
          invalid={!!fieldState.error}
        />
      )}
    />
  );
};
